var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tabs-view',{attrs:{"default-tab-on-select":3,"tabs":_vm.Tabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }